const setContractEquipmentCovered = (contract) =>
  contract.equipmentType ? [contract.equipmentType] : [];

const setOutOfHoursSupport = (contract) => {
  if (contract.IsConfigured) {
    if (contract.OutOfHours) return "Yes";
    return "No";
  }
  return "Not Configured";
};

const setAllowedCallers = (contract) => {
  if (contract.allowedCallers) {
    return contract.allowedCallers.map((o) => o.callerType);
  }
  return [];
};

const setPurchaseOrderRequired = (contract) => Boolean(contract.isConfigured);

const setIsConfigured = (contract) => Boolean(contract.IsConfigured);

class ContractModel {
  constructor(contract = {}) {
    this.contractId = contract.contractID || null;
    this.clientName = contract.clientName || null;
    this.contractType = contract.contractType || null;
    this.purchaseOrder = contract.PurchaseOrder || null;
    this.purchaseOrderExpire = contract.PurchaseOrderExpire || null;
    this.isConfigured = setIsConfigured(contract);
    this.equipmentCovered = setContractEquipmentCovered(contract);
    this.outOfHoursSupport = setOutOfHoursSupport(contract);
    this.allowedCallers = setAllowedCallers(contract);
    this.purchaseOrderRequired = setPurchaseOrderRequired(contract);
  }

  mergeContract(contract) {
    this.updateEquipmentCovered(contract);
    this.updateAllowedCallers(contract);
    this.updatePurchaseOrder(contract);
    this.updateOutOfHoursSupport(contract);
    this.updateIsConfigured(contract);
  }

  updateEquipmentCovered(contract) {
    if (contract.equipmentType) {
      this.equipmentCovered = [
        ...new Set([...this.equipmentCovered, contract.equipmentType]),
      ];
    }
  }

  updateAllowedCallers(contract) {
    if (contract.allowedCallers) {
      const callerTypes = contract.allowedCallers.map((o) => o.callerType);
      this.allowedCallers = [
        ...new Set([...this.allowedCallers, ...callerTypes]),
      ];
    }
  }

  updatePurchaseOrder(contract) {
    if (!this.purchaseOrderRequired) {
      this.purchaseOrderRequired = Boolean(contract.isConfigured);
    }

    if (!this.purchaseOrder) {
      this.purchaseOrder = contract.PurchaseOrder || null;
    }

    if (!this.purchaseOrderExpire) {
      this.purchaseOrderExpire = contract.PurchaseOrderExpire || null;
    }
  }

  updateOutOfHoursSupport(contract) {
    if (this.outOfHoursSupport === "Not Configured")
      this.outOfHoursSupport = setOutOfHoursSupport(contract);
  }

  updateIsConfigured(contract) {
    if (this.isConfigured === false) {
      this.isConfigured = Boolean(contract.IsConfigured);
    }
  }
}

export default ContractModel;
